import { useLocation } from "react-router-dom";
import { AppNavHeader } from "./AppNavHeader";

/**
 * Renders the global navigation header on internal pages.
 * Hidden on landing (/), auth pages, legal pages, and shared views.
 */
export const GlobalNavHeader = () => {
  const { pathname } = useLocation();

  // Active quiz-question screen owns its own inline header (Home + TTS + numeration).
  const isActiveQuizQuestion =
    pathname.startsWith("/quiz/") && pathname.split("/").length >= 4;

  // Practice by modules (/quiz) renders its own inline Back/Home controls.
  // Without this, AppNavHeader would render an EMPTY bar (back/home/messages/logout
  // all hidden) whose border-b showed as a stray line + blank space above the page.
  const isModulesIndex = pathname === "/quiz";

  const isExcluded =
    pathname === "/" ||
    pathname.startsWith("/auth/") ||
    pathname.startsWith("/legal/") ||
    pathname === "/privacy" ||
    pathname === "/support" ||
    pathname === "/faq" ||
    pathname.startsWith("/share/") ||
    pathname === "/real-exam" ||
    pathname === "/exam-simulation" ||
    isModulesIndex ||
    isActiveQuizQuestion;

  if (isExcluded) return null;


  // Quiz-active pages need confirm before leave
  const isQuizActive =
    (pathname.startsWith("/quiz/") && pathname.split("/").length >= 4) ||
    pathname === "/exam-simulation" ||
    pathname === "/real-exam";

  // Practice/study/module/quiz screens: minimal nav (only Home).
  // No logout, no messages — reduce distractions during practice.
  const isPracticeScreen =
    pathname.startsWith("/quiz") ||
    pathname.startsWith("/study") ||
    pathname.startsWith("/review-bank") ||
    pathname.startsWith("/visual-anatomy") ||
    pathname.startsWith("/anatomy") ||
    pathname === "/exam-simulation" ||
    pathname === "/real-exam";

  return (
    <AppNavHeader
      confirmBeforeLeave={isQuizActive}
      hideBack
      hideHome={pathname === "/dashboard" || pathname === "/admin-cohorts" || pathname === "/quiz"}
      hideMessages={isPracticeScreen}
      hideLogout={isPracticeScreen}
    />
  );
};
